module.exports = __webpack_public_path__ + "img/grey.7d488684.png";